import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 380px;
  max-width: 80%;

  .initial-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 3rem;

    @media (max-width: 600px) {
      padding-top: 5rem;
    }

    p {
      text-align: justify;
    }
  }

  .footer-button {
    display: flex;
    justify-content: center;
  }


  #fitbit-button {
    background-color: var(--light-blue);
    color: white;
    border: var(--light-blue);
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: 0.3rem;
    width: 40%;

    &:hover {
      filter: brightness(85%)
    }

    @media (max-width: 600px) {
      margin-top: -1rem;
      width: 70%;
    }
  }
`;